/**
 * Copyright © 2026 Adnuntius AS.
 * UI-Router state declarations.
 */
import {Ng2StateDeclaration} from '@uirouter/angular';
import {firstValueFrom, tap} from 'rxjs';

import {UserProfileSaverService} from '../../components/session/user-profile-saver.service';
import {SignalAdminResourceContextActionsComponent} from '../common/controller/signal-admin-resource-context-actions.component';
import {SignalAdminResourcePageState} from '../common/controller/signal-admin-resource-page-state';
import {SignalAdminResourceTitleComponent} from '../common/controller/signal-admin-resource-title.component';
import {ListDefaultActionsComponent} from '../common/directives/list-default-actions.component';
import {stateTitleView} from '../common/directives/html/state-title.component';
import {AdnRouterHelperApi, StateDeclarationBuilder} from '../routing/state-utils';
import {TriggerApiService, TriggerModel} from './trigger-api.service';
import {TriggerCopyModalComponent} from './trigger-copy-modal.component';
import {TriggerEditPageComponent} from './trigger-edit-page.component';
import {TriggerRoutePageComponent} from './trigger-route-page.component';

export function triggerStates(adnRouterHelper: AdnRouterHelperApi): Ng2StateDeclaration[] {
  const states = new StateDeclarationBuilder();
  const api = adnRouterHelper.services.service(TriggerApiService);
  const userProfileSaver = adnRouterHelper.services.service(UserProfileSaverService);
  const rh = adnRouterHelper.createRouterHelper('triggers.trigger', TriggerApiService, 'app.dat-seg', 'app');
  const copyConfig = {
    modalComponent: TriggerCopyModalComponent,
    stateUrl: 'app.dat-seg.triggers.trigger',
    lcase: 'trigger',
    ucase: 'Trigger'
  };

  states.add(rh.listPath(), rh.list({
    resolve: {listReadOnly: () => false},
    views: {
      'content@app': {component: TriggerRoutePageComponent, bindings: {readOnly: 'listReadOnly'}},
      'context@app': {component: ListDefaultActionsComponent, bindings: {readOnly: 'listReadOnly', newStateName: 'listNewStateName'}},
      'title@app': stateTitleView()
    }
  }));
  states.add(rh.newItemPath(), rh.newItem());
  states.add(rh.itemPath(), rh.item({
    resolve: {
      triggerPage: function($stateParams: any) {
        if ($stateParams.isNew) {
          return new SignalAdminResourcePageState<TriggerModel>(
            {id: $stateParams.id, objectState: 'ACTIVE', validationWarnings: []}, true, false, api, 'Trigger', 'name', copyConfig
          );
        }
        return firstValueFrom(api.get($stateParams.id).pipe(
          tap((model) => userProfileSaver.saveObj(model, 'adnLastViewed'))
        )).then((model) => new SignalAdminResourcePageState(model, false, false, api, 'Trigger', 'name', copyConfig));
      },
      model: function(triggerPage: SignalAdminResourcePageState<TriggerModel>) {
        return triggerPage.model();
      }
    },
    views: {
      'content@app': {component: TriggerEditPageComponent, bindings: {state: 'triggerPage'}},
      'context@app': {component: SignalAdminResourceContextActionsComponent, bindings: {state: 'triggerPage'}},
      'title@app': {component: SignalAdminResourceTitleComponent, bindings: {state: 'triggerPage'}}
    }
  }));
  return states.build();
}
